import type { FunctionComponent } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { colorsPalettes } from "@similarweb/styles";
import type { IListItem } from "./types";
import { Bullet, TooltipContainer, Text, Header, HeadersContainer, ListItemContainer, FlexRow } from "./styled";
const { carbon } = colorsPalettes;

const ListItem: FunctionComponent<{ listItem: IListItem }> = (props) => {
    const { listItem } = props;
    const { color, displayText, displayValue } = listItem;
    return (
        <ListItemContainer>
            <FlexRow>
                <Bullet color={color} />
                <Text>{displayText}</Text>
            </FlexRow>
            <Text color={carbon[300]}>{displayValue}</Text>
        </ListItemContainer>
    );
};

export const ListItemsTooltip: FunctionComponent<{ listItems: IListItem[] }> = (props) => {
    const { listItems } = props;
    const i18n = i18nFilter();
    const renderItem = (listItem: IListItem, index: number) => (
        <ListItem
            key={index}
            listItem={listItem}
        />
    );
    return (
        <TooltipContainer>
            <HeadersContainer>
                <Header>{i18n("common.domain")}</Header>
                <Header>{i18n("common.site.share")}</Header>
            </HeadersContainer>
            <div>{listItems.map(renderItem)}</div>
        </TooltipContainer>
    );
};
